// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chartbar2[data-v-0ba9590d]{width:100%;height:100%;display:flex;flex-direction:column;position:relative}.chartbar2 .nodata[data-v-0ba9590d]{height:100%;width:100%;position:absolute;top:0;left:0;background-color:hsla(0,0%,100%,.7);z-index:100;text-align:center;line-height:15.625vw}", ""]);
// Exports
module.exports = exports;
